import React from 'react';
import logo from './logo.png'; // adjust the path to your logo file
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <header className="landing-header">
        <img src={logo} alt="Logo" className="landing-logo" />
      </header>
      <main className="landing-content">
        <h1>Welcome to KanhaMatrimonials</h1>
        <p>
          We cater to the most discerning clients; our team of high-profile matchmakers takes the time to understand your unique requirements to ensure a seamless experience.
        </p>
        <p>
          Ready to begin your journey to finding your soulmate? <strong>Get in touch with us today!</strong>
        </p>
        <p>
          <strong>📧 <a href="mailto:support@kanhamatrimonials.com">support@kanhamatrimonials.com</a></strong>
        </p>
        <p>
          <strong>Office:</strong> +91 76050 33092
        </p>
        <p>
          <strong>Locations in India:</strong> <em>Kolkata, Mumbai, New Delhi, Ahmedabad, Jaipur, Bangalore, Hyderabad</em>
        </p>
        <p>
          <strong>International:</strong> <em>Singapore, London, USA</em>
        </p>
        <p>
          Let us help you find the perfect match. We handle your personal information with the utmost confidentiality, providing a secure and trusted environment for your search.
        </p>
      </main>
      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} Kanha Matrimonials. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
